module.exports = __webpack_public_path__ + "static/media/teal-play-icon.5085b59d.svg";